// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"619":"948069da","988":"74007c0d"}[chunkId] + ".chunk.js";
};